/* unplugin-vue-components disabled */import { render } from "./mapshadow.vue?vue&type=template&id=623d1360&scoped=true"
import script from "./mapshadow.vue?vue&type=script&lang=js"
export * from "./mapshadow.vue?vue&type=script&lang=js"

import "./mapshadow.vue?vue&type=style&index=0&id=623d1360&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d1360"]])

export default __exports__